import { CloudPercentIcon } from './CloudPercentIcon';

/**
 * author: Simran
 * id 63C6361B-587A-4EF6-9308-8E54DD1BB68E
 * name cloud-percent
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-percent.svg
 * tags
 * - Weather 
 * - Cloud 
 * - Nature 
 */
export const RainChanceIcon = CloudPercentIcon;
export default RainChanceIcon